import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-5.png');

class Specialization extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1" style={{backgroundImage:"url(" + bnr1 + ")",  borderBottom: "1px solid #337ab7"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                                <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic1.jpg')} alt=""/>
                                        <div className="figcaption">
                                            <h4>Kosultacjie społeczne</h4>
                                            <p> Słuchamy Waszych głosów z pasją i doświadczeniem – razem kształtujemy skateparki marzeń!</p>
                                            <NavLink to="/project-detail" ><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic2.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>Projektowanie</h4>
                                            <p> Projektujemy z miłością do sportu i wieloletnim doświadczeniem – tworzymy miejsca, które inspirują i wyzwaniają!</p>
                                            <NavLink to="/project-detail" ><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4  col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/pic3.jpg')} alt="" />
                                        <div className="figcaption bg-dark">
                                            <h4>Wykonanie</h4>
                                            <p>Zadania realizujemy z pasją i profesjonalizmem – każdy detal naszych skateparków to efekt naszej miłości do jazdy ekstremalnej!</p>
                                            <NavLink to="/project-detail" ><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12 col-sm-6 m-b30">
                                    <div className="mt-box our-speciallization-content">
                                        <h3 className="m-t0"><span className="font-weight-100"> Skate Arena Workshop</span> <br /></h3>
                                        <p>
Zaangażowanie, pasja i wieloletnie doświadczenie w jeździe ekstremalnej kształtują każdy etap naszej pracy, od konsultacji społecznych, przez projektowanie, aż po wykonanie, tworząc skateparki, które spełniają marzenia i oczekiwania użytkowników.</p>
                                        <NavLink to="/project-detail"  className="site-button btn-effect">View All</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l150 text-uppercase ">
                        <strong>Od konsultacji do realizacji</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization;